import React from 'react'

import { Box, Typography, LinearProgress, Tooltip } from '@mui/material'

import { theme } from 'styles/theme'

interface ProgressBarProps {
  label: string
  value: {
    actual: number
    max: number
  }
  tooltip?: string
}

const ProgressBar = ({ label, value, tooltip }: ProgressBarProps) => {
  const percentage = (value.actual / value.max) * 100

  return (
    <Tooltip title={tooltip || ''} arrow placement="bottom">
      <Box
        display="flex"
        flexDirection="column"
        gap="5px"
        sx={{ cursor: tooltip ? 'help' : 'default', minWidth: '150px' }}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          gap="8px"
        >
          <Typography
            sx={{
              [theme.breakpoints.down(960)]: {
                fontSize: '12px'
              }
            }}
            color="#fff"
            fontWeight="300"
            variant="xsLight"
          >
            {label}
          </Typography>
          <Typography
            sx={{
              [theme.breakpoints.down(960)]: {
                fontSize: '12px'
              }
            }}
            color="#fff"
            fontWeight="500"
            variant="xsLight"
          >
            {value.actual} de {value.max}
          </Typography>
        </Box>
        <LinearProgress
          variant="determinate"
          value={percentage}
          sx={{
            height: 4,
            width: '100%',
            borderRadius: 4,
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            '& .MuiLinearProgress-bar': {
              backgroundColor: '#ffffff'
            }
          }}
        />
      </Box>
    </Tooltip>
  )
}

export default ProgressBar
